const STATUSES = Object.freeze({
    FULL_TIME: 'Full-Time',
    PART_TIME: 'Part-Time',
    TERMINATED: 'Terminated',
  });

const STATUS_ARRAY = [
  STATUSES.FULL_TIME,
  STATUSES.PART_TIME,
  STATUSES.TERMINATED,
];


module.exports = {
  STATUSES,
  STATUS_ARRAY
}